
angular.module("dashboard_space")

    .controller('DashboardSpaceShowCtrl', ['$rootScope', '$scope', 'Restangular', '$filter', '$translate', '$stateParams', '$state', '$timeout', 'LoginService', '$q', '$log', function ($rootScope, $scope, Restangular, $filter, $translate, $stateParams, $state, $timeout, LoginService, $q, $log) {
       
        $scope.id = $stateParams.spaceId;
        $scope.isFirstLoad = true;

        $scope.searchOptions = {
            event_space_id: $scope.id ?? -1,
            name_surnames: "",
            position_name: "",
        };

        $scope.searchResult = { data: null };

        Restangular.one('eventsspaces/' + $stateParams.id + "/edit/" + $stateParams.spaceId).get().then(function (result) {
            
            $scope.space = result;

        });

        // Guardamos todos los invitados del evento para poder filtrarlos localmente
        let allEventGuest = [];

        // Grid de invitados sentados en el espacio 
        $scope.gridEventSpaceShow = {
            rowHeight: 50,
            pdfTitle: $filter('translate')('events.spaces.guests_title'),
            exporterMenuCsv: false,
            enableGridMenu: false,
            enableSorting: false,
            paginationPageSizes: [50, 100, 150],
            enableSelectionBatchEvent: true,//para obtener los seleccionados
            paginationPageSize: 50,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [ 
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true, allowCellFocus: false },
                {
                    enableCellEdit: false,
                    allowCellFocus: false,
                    name: 'name',
                    displayName: $filter('translate')('events.spaces.guest_name'),
                    enableFiltering: false,
                    enableHiding: false,
                    cellTemplate: '<div class="ui-grid-cell-contents"> <div> {{row.entity.FK_events_guests_persons.surname + (row.entity.FK_events_guests_persons.lastname ? " " + row.entity.FK_events_guests_persons.lastname + ", " : ", ") + row.entity.FK_events_guests_persons.name}} <div> <div> {{row.entity.position}} </div> </div>',
                },
                {
                    enableCellEdit: false,
                    allowCellFocus: false,
                    name: 'zone',
                    displayName: $filter('translate')('events.spaces.guest_zone'),
                    enableFiltering: false,
                },
            ],
            getData: function (options) {

                options = { ...options, ...$scope.searchOptions }

                // los pedimos al servidor
                return Restangular.all("EventsGuests").customGET("SearchGuestLocation", options).then(function (results) {

                    // Si no es la primera carga, marcamos que estamos haciendo una búsqueda activa.
                    if ($scope.isFirstLoad == true) {
                        $scope.isFirstLoad = false;
                    } else {
                        $scope.activeSearch = true;
                    }

                    $scope.searchResult.data = results;
                    return $scope.searchResult.data;

                });

            }
        };

        $scope.loadGuest = function () {
            $scope.gridEventSpaceShow.loadData(false);
        }

    }])
    
;